<ng-container *transloco="let t">
  @if (label()) {
  <div [class]="labelClass()">
    <label [for]="controlId()" class="text-xs font-medium text-ink tracking-tight">
      {{ t(label()) }} @if (!disabled() && required()) {
      <span class="text-danger" aria-hidden="true"> *</span>
      }
    </label>
  </div>
  }

  <div #origin class="relative" [class]="appliedClasses() || ''">
    <input
      type="text"
      ngCombobox
      #combobox="ngCombobox"
      class="form-input w-full pe-10"
      [class.input-error]="showError()"
      [class.disabled]="disabled()"
      [id]="controlId()"
      [name]="controlId()"
      [placeholder]="t(placeholder())"
      [disabled]="disabled()"
      [readonly]="pending()"
      [expanded]="popupExpanded()"
      [(value)]="filterText"
      [attr.aria-label]="label() ? null : t(ariaLabel()) || null"
      [attr.aria-required]="required()"
      [attr.aria-busy]="pending()"
      [attr.aria-invalid]="showError()"
      [attr.aria-describedby]="showError() ? controlId() + '-error' : null"
      (expandedChange)="onExpandedChange($event)"
      (click)="openDropdown()"
    />
    <mat-icon
      svgIcon="alt-arrow-down-outline"
      class="juno-autocomplete__chevron"
      [class.juno-autocomplete__chevron--open]="popupExpanded()"
      aria-hidden="true"
    ></mat-icon>
  </div>

  <ng-template
    [cdkConnectedOverlay]="{ origin: origin, matchWidth: true,usePopover: 'inline'}"
    [cdkConnectedOverlayOpen]="popupExpanded()"
    (overlayOutsideClick)="onExpandedChange(false)"
    (detach)="onExpandedChange(false)"
  >
    <ng-template ngComboboxPopup [combobox]="combobox">
      <ul
        ngListbox
        ngComboboxWidget
        #listbox="ngListbox"
        [tabindex]="-1"
        focusMode="activedescendant"
        selectionMode="explicit"
        [value]="listboxValue()"
        [activeDescendant]="listbox.activeDescendant()"
        (valueChange)="onListboxValueChange($event)"
        (wheel)="onDropdownWheel($event)"
        class="juno-autocomplete__dropdown"
        animate.enter="juno-autocomplete__dropdown--enter"
        animate.leave="juno-autocomplete__dropdown--leave"
      >
        @for (option of filteredOptions(); track option.value) {
        <li ngOption [value]="option.value" [label]="option.label" class="juno-autocomplete__option">
          {{ option.label }}
        </li>
        } @empty {
        <li class="juno-autocomplete__no-results" aria-live="polite">{{ t(noResultsKey()) }}</li>
        }
      </ul>
    </ng-template>
  </ng-template>

  @if (showError()) {
  <div [id]="controlId() + '-error'" role="alert">
    <juno-libs-ui-error [errors]="errors()"></juno-libs-ui-error>
  </div>
  }
</ng-container>
